import React, { useState, useEffect, useRef } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Box,
  Chip,
  TextField,
  InputAdornment,
  IconButton,
  ListSubheader
} from "@mui/material";
import { FixedSizeList as List } from "react-window";
import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { setState, GetLineItemForDelete, reset } from "../centralAdminSlice";

const MultiSelectSalesOrderRecordDelete = (props) => {
  const dispatch = useDispatch();
  const customerData = props?.SalesOrder;
  const SalesOrderList = customerData?.map((item) => item.salesOrder);
  const [SalesOrder, setSalesOrder] = useState([]);
  const [PreviousSelected, setPreviousSelected] = useState([]);
  const [displayItem, setDisplayItem] = useState(customerData.length - 1);
  const [searchText, setSearchText] = useState("");
  const [namesData, setNamesData] = useState([]);
  const textInput = useRef(null);
  const [selectAll, setSelectAll] = useState(false);
  const state = useSelector((store) => store.centralAdmin);

  const { selectedPeriods, selectedDataSalesOrdersDelete } = state;

  const handleChange = (name) => {
    let items = [...SalesOrder];
    if (items.includes(name)) {
      items = items.filter((item) => item !== name);
    } else {
      items.push(name);
    }
    console.log("Updated SalesOrder:", items);
    setSalesOrder(items);
    setDisplayItem(items.length - 1);
    setSelectAll(items.length === SalesOrderList.length);
  };

  useEffect(() => {
    setNamesData(SalesOrderList);
  }, [customerData]);

  const handleDelete = (e, value) => {
    e.preventDefault();
    setSelectAll(false);
    setSalesOrder(SalesOrder.filter((name) => name !== value));
  };

  useEffect(() => {
    setSelectAll(namesData.length === 0);
  }, [namesData]);

  const handleInputChange = (value) => {
    setSearchText(value);
  };

  const handleSelectAll = () => {
    if (!selectAll) {
      const filtered = searchText
        ? SalesOrderList.filter((name) =>
            name.toLowerCase().includes(searchText.toLowerCase())
          )
        : SalesOrderList;
      setSalesOrder(filtered);
    } else {
      setSalesOrder([]);
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      debugger;
      if (SalesOrderList.length > 0)
      setNamesData(
        searchText
          ? SalesOrderList.filter((name) =>
              name.toLowerCase().includes(searchText.toLowerCase())
            )
          : SalesOrderList
      );
      setTimeout(() => textInput.current?.focus(), 100);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  useEffect(() => {
    if (SalesOrder.length > 0) {
      dispatch(setState("selectedDataSalesOrdersDelete", SalesOrder));
      dispatch(setState("clearIVDValues", false));
      if (
        SalesOrder.length !== PreviousSelected.length ||
        !SalesOrder.every((val, index) => val === PreviousSelected[index])
      ) {
        dispatch(reset("OnSalesOrderChangeDelete"));
        setPreviousSelected(SalesOrder);
        dispatch(
          GetLineItemForDelete({
            selectedPeriods,
            selectedSalesOrder: SalesOrder.join(),
          })
        );
      }
    } else {
      dispatch(setState("selectedDataSalesOrdersDelete", []));
      dispatch(reset("OnSalesOrderChangeDelete"));
      setPreviousSelected([]);
    }
  }, [SalesOrder]);

  useEffect(() => {
    if (selectedDataSalesOrdersDelete.length === 0) {
      setSalesOrder([]);
      setSelectAll(false);
    }
  }, [selectedDataSalesOrdersDelete]);

  return (
    <div>
      <FormControl>
        <InputLabel>Sales Order</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          sx={{ width: 400 }}
          value={SalesOrder}
          size="small"
          input={<OutlinedInput label="MultiSelect" />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.length > 1 ? (
                <>
                  <Chip
                    label={selected[0]}
                    clickable
                    sx={{
                      bgcolor: "darkred.light",
                      color: "white.main",
                      textTransform: "none",
                      mt: 1,
                      mr: 2,
                      "&:hover": {
                        bgcolor: "darkred.main",
                      },
                    }}
                    variant="contained"
                    deleteIcon={
                      <CancelIcon
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      />
                    }
                    onDelete={(e) => handleDelete(e, selected[0])}
                  />
                  <Box sx={{ mt: 1, mr: 2 }}>+ {selected.length - 1}</Box>
                </>
              ) : (
                selected.map((value, index) => (
                  <Chip
                    key={index}
                    label={value}
                    clickable
                    sx={{
                      bgcolor: "darkred.light",
                      color: "white.main",
                      textTransform: "none",
                      mt: 1,
                      mr: 2,
                      "&:hover": {
                        bgcolor: "darkred.main",
                      },
                    }}
                    variant="contained"
                    deleteIcon={
                      <CancelIcon
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      />
                    }
                    onDelete={(e) => handleDelete(e, value)}
                  />
                ))
              )}
            </Box>
          )}
        >
          <MenuItem onClick={handleSelectAll}>
            <Checkbox checked={selectAll} />
            <ListItemText primary="Select All" />
          </MenuItem>
          <ListSubheader>
            <TextField
              size="small"
              inputRef={textInput}
              placeholder=""
              value={searchText}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setSearchText("")}>
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleInputChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          <List
            height={200}
            itemCount={namesData.length}
            itemSize={50}
            width="100%"
          >
            {({ index, style }) => (
              <MenuItem
                key={index}
                value={namesData[index]}
                style={style}
              >
                <div style={{width:"15%",display:"flex",alignItems:"center", gap: 0.5,padding:0}}
                onMouseDown={(e)=>{
                  e.preventDefault();
                  handleChange(namesData[index]);
                }}
                >
                <Checkbox
                  checked={SalesOrder.includes(namesData[index])}
                />
                </div>
                <ListItemText primary={namesData[index]} />
              </MenuItem>
            )}
          </List>
        </Select>
      </FormControl>
    </div>
  );
};

export default MultiSelectSalesOrderRecordDelete;